var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "chat-bottom-section-web width-full float-l" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-web-left-section archived-chat-btm col-12 col-sm-12 col-md-12 col-lg-4 col-lg-4 float-l"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "chat-btm-section-main add-user-main-section width-full float-l"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "add-user-form width-full float-l mt_10 "
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "top-label-section archived-chat-main float-l width-full"
                                    },
                                    [
                                      _vm.isAdmin
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group float-l width-full p_15"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                                },
                                                [_vm._v(" Search Customer ")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-select",
                                                {
                                                  staticClass:
                                                    "custom-ci-auto-search",
                                                  attrs: {
                                                    name: "customerId",
                                                    label: "text",
                                                    filterable: false,
                                                    options: _vm.customerArr,
                                                    placeholder:
                                                      "Select Customer"
                                                  },
                                                  on: {
                                                    search: _vm.onSearchCustomer
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "option",
                                                        fn: function(option) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-center"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      option.text
                                                                    ) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "selected-option",
                                                        fn: function(option) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "selected d-center"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      option.text
                                                                    ) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2564501668
                                                  ),
                                                  model: {
                                                    value: _vm.customerId,
                                                    callback: function($$v) {
                                                      _vm.customerId = $$v
                                                    },
                                                    expression: "customerId"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "no-options" },
                                                    [
                                                      _vm._v(
                                                        "\n                                                        Search Customer...\n                                                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAdmin
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group float-l width-full p_15"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                                },
                                                [_vm._v(" Search User ")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-select",
                                                {
                                                  staticClass:
                                                    "custom-ci-auto-search",
                                                  attrs: {
                                                    name: "userId",
                                                    label: "text",
                                                    filterable: false,
                                                    options: _vm.userArr,
                                                    placeholder: "Select User"
                                                  },
                                                  on: {
                                                    search: _vm.onSearchUser
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "option",
                                                        fn: function(option) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-center"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      option.text
                                                                    ) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "selected-option",
                                                        fn: function(option) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "selected d-center"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      option.text
                                                                    ) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2564501668
                                                  ),
                                                  model: {
                                                    value: _vm.userId,
                                                    callback: function($$v) {
                                                      _vm.userId = $$v
                                                    },
                                                    expression: "userId"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "no-options" },
                                                    [
                                                      _vm._v(
                                                        "\n                                                        Search User...\n                                                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group float-l width-full p_15"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                            },
                                            [_vm._v(" From Date ")]
                                          ),
                                          _vm._v(" "),
                                          _c("date-picker", {
                                            staticClass:
                                              "form-control custom-select",
                                            attrs: {
                                              placeholder: "Select From Date",
                                              id: "fromDate",
                                              name: "From Date",
                                              config: _vm.options
                                            },
                                            model: {
                                              value: _vm.fromDate,
                                              callback: function($$v) {
                                                _vm.fromDate = $$v
                                              },
                                              expression: "fromDate"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "help is-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.from_date_error_msg)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(0)
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group float-l width-full p_15"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                            },
                                            [_vm._v(" To Date ")]
                                          ),
                                          _vm._v(" "),
                                          _c("date-picker", {
                                            staticClass:
                                              "form-control custom-select",
                                            attrs: {
                                              placeholder: "Select To Date",
                                              id: "toDate",
                                              name: "To Date",
                                              config: _vm.options
                                            },
                                            model: {
                                              value: _vm.toDate,
                                              callback: function($$v) {
                                                _vm.toDate = $$v
                                              },
                                              expression: "toDate"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "help is-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.to_date_error_msg)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(1)
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "archived-chat-btn float-l col-12 mt_15"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary internal-large-btn",
                                              attrs: { type: "submit" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getArchivedChat()
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "gradient"
                                              }),
                                              _vm._v(
                                                " Get Archived Chat\n                                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary internal-large-btn internal-small-btn float-r",
                                              attrs: { type: "submit" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.resetArchivedChat()
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "gradient"
                                              }),
                                              _vm._v(
                                                " Reset\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "archived-chat-btn col-12 mt_15"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btm-label-section btm-archived-section btm-archived-section-mobile float-l width-full bgcolor-f5f5f5"
                                    },
                                    [
                                      _vm.isChatWindow
                                        ? _c("chat-window", {
                                            attrs: {
                                              chatWindowData: _vm.chatWindowArr,
                                              flag: _vm.windowFlag,
                                              fromId: _vm.fromId,
                                              toId: _vm.toId,
                                              date: _vm.date
                                            }
                                          })
                                        : _vm.resetFlag &&
                                          _vm.archivedChatArr &&
                                          _vm.archivedChatArr != ""
                                        ? _vm._l(_vm.archivedChatArr, function(
                                            archived,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "archived-chat-detail-box float-l width-full"
                                              },
                                              [
                                                _vm._l(
                                                  _vm.archivedChatArr[index],
                                                  function(
                                                    archivedChat,
                                                    index1
                                                  ) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        { key: index1 },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "color-333333 heading-text-14 line-height-16 float-l font-benton-medium mb_0 archive"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    archivedChat.ymd
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "view-chat-link color-f5911e heading-text-14 line-height-16 float-r right font-benton-medium",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showChatWindow(
                                                                    archivedChat.fromId,
                                                                    archivedChat.toId,
                                                                    archivedChat.ymd
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " View Chat "
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-right"
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "archived-chat-listing float-l width-full"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "archived-chat-listing-left colpie-50 float-l"
                                                                },
                                                                [
                                                                  _c(
                                                                    "h5",
                                                                    {
                                                                      staticClass:
                                                                        "archive-chat-title"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Customer: "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "chat-description"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                archivedChat.fromName
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "chat-description"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                archivedChat.fromEmail
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "archived-chat-listing-right colpie-50 float-l"
                                                                },
                                                                [
                                                                  _c(
                                                                    "h5",
                                                                    {
                                                                      staticClass:
                                                                        "archive-chat-title"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Agent: "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "chat-description"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                archivedChat.toName
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "chat-description"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                archivedChat.toEmail
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          })
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-web-right-section archived-chat-btm-main col-12 col-sm-8 col-md-12 col-lg-8 col-lg-8 float-l"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm.isChatWindow
                              ? _c("chat-window", {
                                  attrs: {
                                    chatWindowData: _vm.chatWindowArr,
                                    flag: _vm.windowFlag,
                                    fromId: _vm.fromId,
                                    toId: _vm.toId,
                                    date: _vm.date
                                  }
                                })
                              : _vm.resetFlag
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btm-label-section btm-archived-section float-l width-full bgcolor-f5f5f5"
                                  },
                                  [
                                    _vm.archivedChatArr &&
                                    _vm.archivedChatArr != ""
                                      ? _vm._l(_vm.archivedChatArr, function(
                                          archived,
                                          mIndex
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: mIndex,
                                              staticClass:
                                                "archived-chat-detail-box float-l width-full"
                                            },
                                            [
                                              _vm._l(
                                                _vm.archivedChatArr[mIndex],
                                                function(
                                                  archivedChat,
                                                  mIndex1
                                                ) {
                                                  return [
                                                    archivedChat.fromId ==
                                                      _vm.logingId ||
                                                    _vm.isAdmin
                                                      ? _c(
                                                          "div",
                                                          {
                                                            key: mIndex1,
                                                            staticClass:
                                                              "archived-chat-listing float-l colpie-100"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "archived-chat-listing-left colpie-23 float-l"
                                                              },
                                                              [
                                                                _c(
                                                                  "h5",
                                                                  {
                                                                    staticClass:
                                                                      "archive-chat-title"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Date: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "btm-chat-info btm-chat-info-date float-l width-full bgcolor-ffffff pt_10 pb_10"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-description"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              archivedChat.ymd
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "archived-chat-listing-left colpie-30 float-l"
                                                              },
                                                              [
                                                                _c(
                                                                  "h5",
                                                                  {
                                                                    staticClass:
                                                                      "archive-chat-title"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Customer: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-description"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              archivedChat.fromName
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-description"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              archivedChat.fromEmail
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "archived-chat-listing-right colpie-30 float-l"
                                                              },
                                                              [
                                                                _c(
                                                                  "h5",
                                                                  {
                                                                    staticClass:
                                                                      "archive-chat-title"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Agent: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-description"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              archivedChat.toName
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-description"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              archivedChat.toEmail
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "archived-chat-listing-right archived-chat-view-web colpie-17 float-l"
                                                              },
                                                              [
                                                                _c(
                                                                  "h5",
                                                                  {
                                                                    staticClass:
                                                                      "archive-chat-title view-chat-title"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " View Chat "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.showChatWindow(
                                                                              archivedChat.fromId,
                                                                              archivedChat.toId,
                                                                              archivedChat.ymd
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-angle-right"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        })
                                      : [
                                          _c(
                                            "div",
                                            { staticClass: "no-data-found" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.noConversationData)
                                              )
                                            ]
                                          )
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "hi-icon icon-chatcalendar" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "hi-icon icon-chatcalendar" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02f1b6cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f1b6cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List/ArchivedChat.vue
// module id = null
// module chunks = 